import { make } from 'vuex-pathify'
import axios from 'axios'

const state = {
  referenceAddress: '',
  geoCodedAddress: '',
  geoCodedLocation: null,
  geoLocationAvailable: 'geolocation' in navigator,
  locationPending: false,

  // Default to the district office's location
  geoLocation: null,
}

export default {
  namespaced: true,

  state,

  mutations: {
    ...make.mutations(state), // Include mutations generated by vuex-pathify
    SET_GEO_LOCATION(state, locationData) {
      console.log('SET_GEO_LOCATION Mutation:', locationData);
      state.geoLocation = locationData;
    },
  },

  actions: {
    ...make.actions(state),

    async init({ dispatch }) {},

    reset({ commit }) {
      commit('SET_REFERENCE_ADDRESS', '')
      commit('SET_GEO_CODED_ADDRESS', '')
      commit('SET_GEO_CODED_LOCATION', null)
      commit('SET_GEO_LOCATION', null)
    },

    async lookupAddress({ commit, getters }) {
      if (!getters.userLocation) return ''
      try {
        let { data } = await axios.get(
          'https://nominatim.openstreetmap.org/reverse',
          {
            params: {
              format: 'jsonv2',
              lat: getters.userLocation.lat,
              lon: getters.userLocation.lon,
              zoom: 18,
              addressdetails: 1,
              namedetails: 1,
            },
          }
        )
        if (data) {
          commit(
            'SET_GEO_CODED_ADDRESS',
            `${data.address.house_number || ''} ${data.address.road ||
              ''} ${data.address.city || ''} ${data.address.state || ''} ${data
              .address.postcode || ''}`.trim()
          )
        }
        return data
      } catch (error) {
        throw new Error(error)
      }
    },

    async requestGeoLocation({ state, commit, dispatch }) {
      try {
        let result = await new Promise((resolve, reject) => {
          commit('SET_LOCATION_PENDING', true)
          if (state.geoLocationAvailable) {
            navigator.geolocation.getCurrentPosition(
              // Success
              position => {
                console.log('Geolocation successful:', position) // Log position data

                commit('SET_GEO_LOCATION', {
                  lat: Number(position.coords.latitude),
                  lon: Number(position.coords.longitude),
                })
                commit('SET_LOCATION_PENDING', false)

                resolve({
                  lat: Number(position.coords.latitude),
                  lon: Number(position.coords.longitude),
                })
              },
              // Failure (user canceled?)
              error => {
                console.error('Geolocation error:', error) // Log geolocation error
                commit('SET_LOCATION_PENDING', false)
                reject(error)
              },
              { enableHighAccuracy: true }
            )
          } else {
            commit('SET_LOCATION_PENDING', false)
            console.error('Geolocation not available') // Log geolocation not available
            reject('Geolocation not available')
          }
        })
      } catch (err) {
        console.error('Error in requestGeoLocation:', err) // Log any other errors
        throw new Error(err)
      }
    },

    async geoCodeAddress({ state, commit }, address) {
      if (!address || typeof address === 'undefined') {
        address = state.referenceAddress;
      }

      console.log('Geocoding address:', address);

      try {
        let { data } = await axios.get(
          'https://nominatim.openstreetmap.org/search',
          {
            params: {
              q: address,
              format: 'json',
              countrycodes: 'us',
              addressdetails: 1,
              namedetails: 1,
            },
          }
        );

        console.log('Geocoding response:', data);

        if (data.length > 0) {
          commit('SET_GEO_CODED_LOCATION', {
            lat: Number(data[0].lat),
            lon: Number(data[0].lon),
          });

          console.log('Geocoded location:', {
            lat: Number(data[0].lat),
            lon: Number(data[0].lon),
          });

          // Also update geoLocation in state to trigger userLocation update
          commit('SET_GEO_LOCATION', {
            lat: Number(data[0].lat),
            lon: Number(data[0].lon),
          });

          console.log('Updated geoLocation in geoCodeAddress:', state.geoLocation);

        }
        return data;
      } catch (error) {
        console.error('Error in geoCodeAddress:', error);
        throw new Error(error);
      }
    },
  },

  getters: {
    userLocation: (state, getters, rootState, rootGetters) => {
      const location = state.geoLocation || state.geoCodedLocation || null;
      console.log('userLocation Getter:', location);
      return location;
    },
  },
}
